import { z } from 'zod'

// Update Order Active Appointments Request
export const UpdateOrderActiveAppointmentsRequestSchema = z.object({
  orderId: z.string(),
  appointments: z.array(
    z.object({
      date: z.string(),
      slot: z.string(),
      visitType: z.string(),
      contactFirstName: z.string(),
      contactLastName: z.string(),
      contactPhoneNumber: z.string(),
      selectedNotes: z.array(z.string()).optional(),
    }),
  ),
})

export type UpdateOrderActiveAppointmentsRequest = z.infer<typeof UpdateOrderActiveAppointmentsRequestSchema>

export const BroadbandAppointmentSchema = z.object({
  id: z.string(),
  appointmentDate: z.string(),
  slot: z.string(),
  earliestArrivalTime: z.string(),
  latestArrivalTime: z.string(),
  visitType: z.string(),
  estimatedDurationInMinutes: z.number(),
  inHomeLeadTimeInDays: z.number(),
  state: z.string(),
  notes: z.string().optional(),
  healthAndSafetyNotes: z.string().optional(),
  contactFirstName: z.string(),
  contactLastName: z.string(),
  contactPhoneNumber: z.string(),
  contactSecondaryPhoneNumber: z.string().optional(),
  engineerName: z.string().optional(),
  engineerContactNumber: z.string().optional(),
  amendable: z.boolean(),
  formattedArrivalTime: z.string(),
})

// Update Order Active Appointments Response
export const UpdateOrderActiveAppointmentsResponseSchema = z.array(BroadbandAppointmentSchema)

export type UpdateOrderActiveAppointmentsResponse = z.infer<typeof UpdateOrderActiveAppointmentsResponseSchema>
